export const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

export const GAME_NAMES = ["flowers", "bubbles", "polygons", "tiles", "words"] as const;

export const DAY_0 = "2025-04-01T00:00:01+0000";
